import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, withKeys as _withKeys, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "container text-center mb-10",
  style: {"margin-top":"-40px"}
}
const _hoisted_2 = { class: "row justify-content-center" }
const _hoisted_3 = { class: "col-sm-12 col-md-12 col-lg-12" }
const _hoisted_4 = { class: "card shadow" }
const _hoisted_5 = { class: "card-body" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-sm-12 col-md-6 col-lg-2" }
const _hoisted_8 = { class: "col-sm-12 col-md-6 col-lg-3" }
const _hoisted_9 = { class: "col-sm-12 col-md-10 col-lg-5" }
const _hoisted_10 = { class: "col-sm-3 col-md-2 col-lg-2" }
const _hoisted_11 = { class: "container" }
const _hoisted_12 = {
  key: 0,
  class: "content"
}
const _hoisted_13 = { class: "text-center mb-10" }
const _hoisted_14 = { class: "fw-normal" }
const _hoisted_15 = { class: "row justify-content-center mb-10" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_sub_header = _resolveComponent("sub-header")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_KTFile = _resolveComponent("KTFile")!
  const _component_el_empty = _resolveComponent("el-empty")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Header),
    _createVNode(_component_sub_header, {
      title: 'Descarga de certificados',
      "sub-title": `
    Bienvenido a nuestra plataforma, aquí podrás descargar tu <br> 
    certificado o constancia de participación en eventos deportivos y acádemicos<br> que has
    completado con éxito`
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_el_form, {
                ref: "searchFormRef",
                model: _ctx.searchForm,
                rules: _ctx.rules,
                "label-width": "auto",
                class: "demo-ruleForm",
                size: 'default'
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _createVNode(_component_el_form_item, {
                        prop: "periodo",
                        label: "Periodo",
                        class: "w-100",
                        rules: [{
                                        required: true,
                                        message: 'Campo requerido',
                                        trigger: ['blur', 'change']
                                        }]
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.searchForm.periodo,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchForm.periodo) = $event)),
                            maxlength: 4,
                            class: "w-100"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_8, [
                      _createVNode(_component_el_form_item, {
                        prop: "category",
                        label: "Tipo",
                        class: "w-100",
                        rules: [{
                                        required: true,
                                        message: 'Campo requerido',
                                        trigger: ['blur', 'change']
                                    }]
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            modelValue: _ctx.searchForm.category,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchForm.category) = $event)),
                            placeholder: "- Seleccione -",
                            class: "w-100"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_option, {
                                label: "Deportivo",
                                value: "1"
                              }),
                              _createVNode(_component_el_option, {
                                label: "Académico",
                                value: "2"
                              })
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_9, [
                      _createVNode(_component_el_form_item, { prop: "docnumber" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.searchForm.docnumber,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.searchForm.docnumber) = $event)),
                            placeholder: "Nro de documento",
                            class: "w-100",
                            minlength: _ctx.searchForm.doctype == '1' ? 8 : 3,
                            maxlength: _ctx.searchForm.doctype == '1' ? 8 : 13,
                            "show-word-limit": true,
                            onKeypress: _cache[5] || (_cache[5] = _withKeys(($event: any) => (_ctx.submitForm(_ctx.searchFormRef)), ["enter"]))
                          }, {
                            prepend: _withCtx(() => [
                              _createVNode(_component_el_select, {
                                modelValue: _ctx.searchForm.doctype,
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.searchForm.doctype) = $event)),
                                style: {width:'160px'},
                                placeholder: "- Seleccione -",
                                onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.searchForm.docnumber = ''))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_option, {
                                    label: "DNI",
                                    value: "1"
                                  }),
                                  _createVNode(_component_el_option, {
                                    label: "Carnet de Ext.",
                                    value: "2"
                                  }),
                                  _createVNode(_component_el_option, {
                                    label: "Pasaporte",
                                    value: "3"
                                  })
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          }, 8, ["modelValue", "minlength", "maxlength"])
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_10, [
                      _createVNode(_component_el_button, {
                        type: "success",
                        class: "w-100",
                        loading: _ctx.loading,
                        onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.submitForm(_ctx.searchFormRef)))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Buscar")
                        ]),
                        _: 1
                      }, 8, ["loading"])
                    ])
                  ])
                ]),
                _: 1
              }, 8, ["model", "rules"])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      (_ctx.listCourses.length>0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("h5", _hoisted_14, "Se encontró " + _toDisplayString(_ctx.listCourses.length) + " resultado" + _toDisplayString(_ctx.listCourses.length == 1 ? '' : 's'), 1)
            ]),
            _createElementVNode("div", _hoisted_15, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listCourses, (item, index) => {
                return (_openBlock(), _createBlock(_component_KTFile, {
                  key: 'fil-' + index,
                  "file-title": item.name,
                  "file-type": 'pdf',
                  download: true,
                  file: `${_ctx.urlDownload}/public/certificate/${item.idsm}/download`,
                  "created-at": "3 days ago"
                }, null, 8, ["file-title", "file"]))
              }), 128))
            ])
          ]))
        : (_openBlock(), _createBlock(_component_el_empty, {
            key: 1,
            description: "No se encontró información para mostrar"
          }))
    ])
  ], 64))
}